import React from 'react'
import ReactDOM from 'react-dom'
import AccelerometerLineChart from '../ReactComponents/Components/AccelerometerLineChart'
import lodash from 'lodash'

angular.module('common.directives').directive('customAccelerometerLineChart', [
  'SystemConstants',
  function (SystemConstants) {
    return {
      scope: {
        accelerometerData: '=',
        referenceValue: '='
      },
      template: '<div class="custom-element"></div>',
      link: ($scope, $element) => {
        const timeScale = [-5, 5]
        const speedScale = SystemConstants.unit === 1 ? [-60, 60] : [-100, 100]
        const xArray = $scope.accelerometerData.map(({ x }) => x)
        const yArray = $scope.accelerometerData.map(({ y }) => y)
        const xScale = [
          (lodash.min(xArray) || -9) - 1,
          (lodash.max(xArray) || 9) + 1
        ].map((v, index, arr) => (index === 0 ? 0 : arr[1] - arr[0]) + v)
        const yScale = [
          (lodash.min(yArray) || -9) - 1,
          (lodash.max(yArray) || 9) + 1
        ].map((v, index, arr) => (index === 0 ? 0 : arr[1] - arr[0]) + v)
        const config = {
          xAxisList: [
            {
              title: 'Time',
              name: 'time',
              scale: timeScale,
              ticksList: (() => {
                const ticks = []
                for (let i = timeScale[0]; i <= timeScale[1]; i++) {
                  ticks.push(i)
                }
                return ticks
              })()
            }
          ],
          yAxisList: [
            {
              title: `GPS SPEED / ${
                SystemConstants.unit === 1 ? '0-60' : '0-100'
              }`,
              name: 'speed',
              scale: speedScale,
              ticksList: (() => {
                const ticks = []
                for (
                  let i = speedScale[0];
                  i <= speedScale[1];
                  i = i + (SystemConstants.unit === 1 ? 60 : 100)
                ) {
                  ticks.push(i)
                }
                return ticks
              })(),
              stroke: 'var(--accelerometer-chart-speed)'
            },
            {
              title: 'FWD',
              name: 'x',
              scale: xScale,
              stroke: 'var(--accelerometer-chart-x)'
            },
            {
              title: 'LAT',
              name: 'y',
              scale: yScale,
              stroke: 'var(--accelerometer-chart-y)'
            }
          ]
        }
        const linkStateUpdater = stateUpdater => {
          $scope.$watchGroup(['data', 'referenceValue'], () => {
            stateUpdater(Math.random())
          })
        }
        ReactDOM.render(
          <AccelerometerLineChart
            getProps={() => ({
              data: $scope.accelerometerData,
              referenceValue: $scope.referenceValue,
              config
            })}
            linkStateUpdater={linkStateUpdater}
          />,
          $element[0]
        )
        $scope.$on('$destroy', () => {
          ReactDOM.unmountComponentAtNode($element[0])
        })
      }
    }
  }
])
